
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalDanger as ObiBuoyConicalDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-danger.js';
 
 
 

 
 export const ObiBuoyConicalDanger = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-danger',
   elementClass: ObiBuoyConicalDangerElement,
   events: {
     
   }
  });
 
 